import axios, { AxiosResponse } from 'axios';

const getService = ()=>{
  if (process.env.NODE_ENV == "development") {
    return "/api"
  } else {
    const origin = 'http://quangao-tech.com.cn/api'
    return origin 
  }
}
export const service_ip =getService();



export const fetch = (
  params,
) => {
  return new Promise((resolve, reject) => {
      params.url = `${service_ip}${params.url}`;
    const method = params.method || 'get'
    const data = method == 'post' ? paramsHandler(params.data || {}) : params.data;
    console.log('data', data)
      axios({
        ...params,
        method: method,
        data: data,
        params: method == 'get' ? data : {},
        withCredentials: true,
        timeout:10000
      })
        .then((res) => {
          console.log('res',res)
          if (typeof res == 'string') {
            res = JSON.parse(res);
          }

          const rResult = res.data;
          if (rResult && rResult.code == 1) {
            console.log(rResult.data)
            resolve(rResult.data);
          } else {
           
          }
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED') {
            return false;
          }
          reject(error);
        });
  });
};

/**
 * post参数处理
 */
export const paramsHandler = function (v) {
  var formData = new FormData()
  for (let i in v) {
    formData.append(i, v[i])
  }
  return formData;
};



//错误码
export const msgCode = (n) => {
  if (n === undefined) {
    return '未知错误';
  }
  n = n.toString();
  switch (n) {
    case '100':
      return 'json解析错误';
    default:
      return '未知错误';
  }
};
